import { apiWordle } from "../../../../services/api"

export interface IBoard {
  rowIndex: number
  boardWords: Array<string>
  boardRowStatus: string[][]
  presentCharArray: Array<string>
  absentCharArray: Array<string>
  correctCharArray: Array<string>
  status: string
  score: number
  repeat: boolean
}

interface IWord {
  encryptedWord: string
  encryptedNormalizedWord: string
  encryptedDefinition: string
}

const getWord = async ():Promise<IWord> => {
  const response = await apiWordle.get('/words').catch(err => {throw err})
  return response.data
};

const verifyWord = async (word:string):Promise<boolean> => {
  const response = await apiWordle.patch('/words/verify', {
    word
  }).catch(err => {throw err})
  return response.data
};

export { getWord, verifyWord };